import {
   Building01Icon,
   FolderOpen01Icon,
   PondIcon,
   StageIcon,
   Tags02Icon,
   BoltIcon,
   SknowFlakeIcon,
} from '@forwardflow/icons'
import { IFilterCriteria } from '../interfaces'

export const PRIMARY_FILTER_OPTIONS = [
   {
      label: 'Tags',
      value: 'tags',
      description:
         'Segment leads by labels or automations from Follow Up Boss.',
      icon: <Tags02Icon />,
   },
   {
      label: 'Source',
      value: 'source',
      description: 'Filter leads by where they came from.',
      icon: <FolderOpen01Icon />,
   },
   {
      label: 'Inquired Properties',
      value: 'inquired_property',
      description:
         'Target leads who submitted a property inquiry for specific addresses.',
      icon: <Building01Icon />,
   },
   {
      label: 'Pond',
      value: 'assigned_pond_id',
      description: 'Choose from shared or team ponds.',
      icon: <PondIcon />,
   },
   {
      label: 'Stage',
      value: 'stage',
      description:
         'Target leads by where they are in your pipeline (e.g. New, Hot, Closed).',
      icon: <StageIcon />,
   },
]

export const ICONS_MAP = {
   source: <FolderOpen01Icon width={16} height={16} />,
   assigned_pond_id: <PondIcon width={16} height={16} />,
   inquired_property: <Building01Icon width={16} height={16} />,
   stage: <StageIcon width={16} height={16} />,
   tags: <Tags02Icon width={16} height={16} />,
}

export const LABEL_MAP = {
   source: 'Sources',
   assigned_pond_id: 'Ponds',
   inquired_property: 'Inquired Properties',
   stage: 'Stages',
   tags: 'Tags',
}

export const FILTER_LABEL_MAP: Record<IFilterCriteria['field'], string> = {
   source: 'Lead Sources',
   assigned_pond_id: 'Ponds',
   inquired_property: 'Inquired Properties',
   stage: 'Stages',
   tags: 'Tags',
}

export const CAMPAIGN_TYPE_OPTIONS = [
   {
      id: 'new-lead',
      label: 'New Leads',
      description:
         'Instantly engage every new inquiry the moment it enters your CRM.',
      icon: <BoltIcon width={23} height={23} color="#9F7BFF" />,
      color: '#9F7BFF',
      showBufferTime: true,
   },
   {
      id: 'revive',
      label: 'Cold Leads',
      description: 'Re-engage past prospects who went cold.',
      icon: <SknowFlakeIcon width={23} height={23} color="#1FB6FF" />,
      color: '#1FB6FF',
      showBufferTime: false,
   },
   {
      id: 'activity',
      label: 'Activity',
      description: 'Trigger a short campaign when a lead shows activity (e.g. saves a property).',
      icon: <BoltIcon width={23} height={23} color="#05DF72" />,
      color: '#05DF72',
      showBufferTime: false,
   },
]
